import PaymentCalculator from './PaymentCalculator.js';
/**
 * Handles financing calculations
 * See section on "How to calculate interest on a car loan" for the formula
 * https://www.thecalculatorsite.com/finance/calculators/carloancalculator.php
 */

class FinancePaymentCalculator extends PaymentCalculator {
  constructor({
    price = 0,
    down = 0,
    term = 48,
    tax = 13,
    rate = 0,
    tradein = 0
  } = {}) {
    super({
      price,
      tradein,
      tax,
      down,
      rate
    });
    this.term = term;
  }

  calculatePayments() {
    if (this.rate <= 0) {
      this.payments = {
        'monthly': this.balance / this.term,
        'biweekly': this.balance / this.term * 12 / 26,
        'weekly': this.balance / this.term * 12 / 52
      };
      return;
    }

    let monthlyInterest = this.rate / 1200;
    this.payments.monthly = this.balance * Math.pow(monthlyInterest + 1, this.term) * monthlyInterest / (Math.pow(monthlyInterest + 1, this.term) - 1);
    this.payments.biweekly = this.payments.monthly * 12 / 26;
    this.payments.weekly = this.payments.monthly * 12 / 52;
  }

  calculateTotalLoanAmount() {
    let monthlyInterestRate = this.rate / 1200;
    this.totalLoanAmount = monthlyInterestRate * this.balance * this.term / (1 - Math.pow(1 + monthlyInterestRate, this.term * -1));
    return this.totalLoanAmount;
  }

  calculateBalance() {
    this.balance = (this.price - this.tradein) * (1 + this.tax / 100) - this.down;
    return this.balance;
  }

  calculate() {
    this.calculateBalance();
    this.calculateTotalLoanAmount();
    this.calculatePayments();
  }

}

export default FinancePaymentCalculator;
//# sourceMappingURL=FinancePaymentCalculator.js.map